import profile1Img from "../../../../assets/images/profile-icon.png";
import profile2Img from "../../../../assets/images/profile-icon-2.png";
import profile3Img from "../../../../assets/images/profile-icon-3.png";

export const dummyDataPatient = [
  {
    name: "Jimmy Daniel",
    profileIcon: profile1Img,
    id: 1,
  },
  {
    name: "Mawar Indah",
    profileIcon: profile2Img,
    id: 3,
  },
  {
    name: "Milo Cornelius",
    profileIcon: profile3Img,
    id: 4,
  },
];
